import React from 'react'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'

const sizes = {
    large: '3rem',
    medium: '2rem',
    small: '1.5rem',
}

const ArrowIcon = styled('i')(({ theme, color, size, direction }) => ({
    border: `solid ${color}`,
    borderWidth: '0 0.15rem 0.15rem 0',
    display: 'inline-block',
    width: sizes[size],
    height: sizes[size],
    '&:hover': {
        cursor: 'pointer',
    },
    ...(direction === 'right' && {
        transform: 'rotate(-45deg)',
        '-webkit-transform': 'rotate(-45deg)',
    }),
    ...(direction === 'left' && {
        transform: 'rotate(135deg)',
        '-webkit-transform': 'rotate(135deg)',
    }),
    ...(direction === 'up' && {
        transform: 'rotate(-135deg)',
        '-webkit-transform': 'rotate(-135deg)',
    }),
    ...(direction === 'down' && {
        transform: 'rotate(45deg)',
        '-webkit-transform': 'rotate(45deg)',
    }),
}))

function KeyboardArrow({ color, size, direction, onClick, style, ariaLabel }) {
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            onClick?.()
        }
    }

    return (
        <ArrowIcon
            onClick={onClick}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            aria-label={ariaLabel}
            color={color}
            size={size}
            direction={direction}
            style={style}
        />
    )
}

KeyboardArrow.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOf(['large', 'medium', 'small']).isRequired,
    direction: PropTypes.oneOf(['left', 'right', 'up', 'down']).isRequired,
    onClick: PropTypes.func.isRequired,
    ariaLabel: PropTypes.string,
}

KeyboardArrow.defaultProps = {
    color: '#000',
    size: 'medium',
    direction: 'down',
}

export default KeyboardArrow
